import { useIsLoggedInRetailerOrBrandPreview } from "@faire/retailer-visitor-shared/lib/isLoggedInRetailer";
import { ProductPagePaths } from "@faire/retailer-visitor-shared/paths/ProductPage";
import {
  shouldUseMetadataZippies,
  useProductPageMetadataShift,
} from "@faire/retailer-visitor-shared/settings/useProductPageMetadataShift";
import { useSettingPdpClickPrefetch } from "@faire/retailer-visitor-shared/settings/useSettingPdpClickPrefetch";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import {
  getQueryFn as getMoreFromBrandQueryFn,
  getQueryKey as getMoreFromBrandQueryKey,
} from "@faire/web-api--source/endpoints/www/api/v2/product/productToken/more-from-brand/get-hooks";
import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import { useLocation } from "react-router-dom";

import {
  BRAND_INFO_ROW_STALE_TIME,
  MAX_NUM_OF_PRODUCTS_TO_DISPLAY,
} from "../BrandInfoRow/consts";

//
export function usePreloadClickToPDP() {
  const queryClient = useQueryClient();
  const isLoggedInRetailerOrBrandPreview =
    useIsLoggedInRetailerOrBrandPreview();
  const { search } = useLocation();
  const enablePDPClickPrefetch = useSettingPdpClickPrefetch();
  const productPageMetadataShiftSetting = useProductPageMetadataShift();
  const shouldUsePdpClickPrefetch = shouldUseMetadataZippies(
    productPageMetadataShiftSetting
  );
  const { isDesktopAndAbove } = useViewport();

  return useCallback(
    (productToken: string) => {
      if (
        !productToken ||
        !isLoggedInRetailerOrBrandPreview ||
        !enablePDPClickPrefetch
      ) {
        return;
      }

      if (shouldUsePdpClickPrefetch && isDesktopAndAbove) {
        // Prefetch more from brand
        const getMoreFromBrandQueryParams = {
          max_results: MAX_NUM_OF_PRODUCTS_TO_DISPLAY,
          referring_product_based_collection_token:
            ProductPagePaths.index.parseSearch(search).collectionRef,
        };

        queryClient.prefetchQuery({
          queryKey: getMoreFromBrandQueryKey(
            productToken,
            getMoreFromBrandQueryParams
          ),
          queryFn: getMoreFromBrandQueryFn(
            productToken,
            getMoreFromBrandQueryParams
          ),
          staleTime: BRAND_INFO_ROW_STALE_TIME,
        });
      }
    },
    [
      queryClient,
      isLoggedInRetailerOrBrandPreview,
      search,
      enablePDPClickPrefetch,
      shouldUsePdpClickPrefetch,
      isDesktopAndAbove,
    ]
  );
}
